import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M21.5,5a2.53,2.53,0,1,0-2.37-1.73.26.26,0,0,1-.06.25L16.4,6.19a.26.26,0,0,1-.31,0A5,5,0,0,0,13.5,5.5a5,5,0,0,0-4,2,.26.26,0,0,1-.3.08L5.07,5.61A.12.12,0,0,1,5,5.5a2.53,2.53,0,1,0-1,2,.25.25,0,0,1,.26,0L8.43,9.38a.24.24,0,0,1,.14.27,6,6,0,0,0-.07.85,5,5,0,0,0,.73,2.6.26.26,0,0,1,0,.31L3.52,19.06a.23.23,0,0,1-.25.06A2.43,2.43,0,0,0,2.5,19a2.53,2.53,0,1,0,2.37,1.73.26.26,0,0,1,.07-.25l5.68-5.67a.24.24,0,0,1,.3,0,5.52,5.52,0,0,0,1.39.58.24.24,0,0,1,.19.24v3.47a.24.24,0,0,1-.12.2,2.5,2.5,0,1,0,2.26,0,.25.25,0,0,1-.14-.23V15.6a.24.24,0,0,1,.19-.24,5,5,0,0,0,2.43-1.44.26.26,0,0,1,.29-.06l1.47.71a.23.23,0,0,1,.14.2,2.49,2.49,0,1,0,.81-2.13.24.24,0,0,1-.27,0l-1.13-.55a.24.24,0,0,1-.14-.29,4.58,4.58,0,0,0,.21-1.34,4.91,4.91,0,0,0-.73-2.58.26.26,0,0,1,0-.31l2.67-2.68a.26.26,0,0,1,.25-.06A2.49,2.49,0,0,0,21.5,5Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }